<template>
  <div
      class="fixed-collapse"
      :style="{height: expanded ? dropdownHeight : 0}"
  >
    <dd-rounded-button
      type="secondary"
      icon="mdi mdi-file-export"
      @click="expanded = !expanded"
    >
      <div class="flex-row gap-sm align-items-center">
        <p class="m-0">Exporteren</p>
        <dd-icon
            :icon="expanded ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'"
            size="md"
            class="color-black"
            style="margin-top: -2px"
        />
      </div>
    </dd-rounded-button>
    <div ref="dropdown">
      <a-select
          v-if="users.length > 1"
          class="aplaza-user-select"
          placeholder="Selecteer een account"
          :defaultValue="selectedAplazaUserId"
          v-on:change="handleAplazaUserChange"
      >
        <a-select-option
            v-for="user in users"
            :key="user.id"
            :value="user.id"
        >
          {{ user.display_name }}
        </a-select-option>
      </a-select>

      <ul style="list-style: none">
        <li
          v-for="option in options"
          @click="option.click"
        >
          <dd-icon
              icon="mdi mdi-chevron-right"
              size="sm"
              class="color-black"
          />
          <span class="paragraph">{{option.title}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import AplazaExportApi from '~/api/aplazaExport';
import aplazaUserApi from "~/api/aplazaUser";

export default {
  name: "ExportButton",
  data(){
    return {
      expanded: false,
      dropdownHeight: 0,
      users: [],
      selectedAplazaUserId: null,
      options: [
        { title: 'FinnConnect (Polis)', click: () => this.export(797) },
        { title: 'FinnConnect (Relatie)', click: () => this.export(800) },
        { title: 'MyTP (Relatie)', click: () => this.export(803)},
      ]
    }
  },
  mounted(){
    aplazaUserApi.getAll().then(({data}) => {
      this.users = data;
      if (data[0]) this.selectedAplazaUserId = data[0].id;

      this.dropdownHeight = this.$refs.dropdown.getBoundingClientRect().height + 40 + 16;
      if (this.users.length > 1) this.dropdownHeight += 30;
    });
  },
  methods: {
    export(providerId){
      AplazaExportApi.export({
        providerId,
        userId: this.selectedAplazaUserId,
        customerId: this.customerId,
        policyId: this.policyId
      })
          .then(data => {
            this.expanded = false;
            if (data.redirect) this.navigator.openPath(data.redirect);
          })
          .catch(() => {
            this.$notification['error']({
              message: 'Er ging iets mis tijdens het exporteren.',
            });
          });
    },
    handleAplazaUserChange(userId){
      this.selectedAplazaUserId = userId;
    }
  },
  computed:{
    customerId(){
      return this.$route.params.customer;
    },
    policyId(){
      return this.$route.params.policy;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/_default.scss';
.fixed-collapse {
  overflow-y: hidden;
  min-height: $spacing-xxl;
  transition: all 200ms ease-in-out;
}
.aplaza-user-select {
  height: $spacing-xl;
  margin-left: $spacing-xxl;
  margin-bottom: $spacing-sm;
  width: calc(100% - #{$spacing-xxl});
}
ul{
  overflow: hidden;
}
li {
  margin-bottom: $spacing-xs;
  cursor: pointer;
  &:active{
    transform: scale(0.93);
  }
}
</style>
<style>
.fixed-collapse:has(button.hide-text){
  width: 0;
}
</style>